import {WikiPageListPage} from "./pages/admin/employee/wiki";
import {SECTION_ACCOUNTING, WikiPageEditPage} from "./pages/admin/employee/wiki/form";
import {NoteAlt as WikiIcon} from "@mui/icons-material";
import {Route} from "react-router-dom";
import * as React from "react";
import SideBarItem from "./sidebar_item";
import {
    AccountBalance,
    AccountTree,
    Assessment,
    AttachMoney,
    Book,
    Business,
    CalendarMonth,
    CompareArrows,
    CreditCard,
    Dashboard,
    Description,
    Euro,
    FormatListBulleted,
    NotificationImportant,
    Receipt,
    Rule,
    Savings,
    SwapHoriz,
    SyncAlt,
    QueryStats,
    Timeline,
} from "@mui/icons-material";
import {AccountingLayout} from "./pages/admin/accounting/layout";
import {AdminAccountingPage} from "./pages/admin/accounting";
import {AccountingDashboardPage} from "./pages/admin/accounting/dashboard";
import {BillAlertsPage} from "./pages/admin/accounting/alerts";
import {ReconciliationPage} from "./pages/admin/accounting/reconciliation";
import {AccountingAccountListPage} from "./pages/admin/accounting/account";
import {AccountingAccountEditPage} from "./pages/admin/accounting/account/form";
import {AccountingPeriodListPage} from "./pages/admin/accounting/period";
import {AccountingPeriodEditPage} from "./pages/admin/accounting/period/form";
import {JournalEntryListPage} from "./pages/admin/accounting/journal";
import {JournalEntryEditPage} from "./pages/admin/accounting/journal/form";
import {SupplierListPage} from "./pages/admin/accounting/supplier";
import {SupplierEditPage} from "./pages/admin/accounting/supplier/form";
import {SupplierBillListPage} from "./pages/admin/accounting/supplier_bill";
import {SupplierBillEditPage} from "./pages/admin/accounting/supplier_bill/form";
import {FixedAssetListPage} from "./pages/admin/accounting/fixed_asset";
import {FixedAssetEditPage} from "./pages/admin/accounting/fixed_asset/form";
import {BankAccountListPage} from "./pages/admin/accounting/bank_account";
import {BankAccountEditPage} from "./pages/admin/accounting/bank_account/form";
import {BankMovementListPage} from "./pages/admin/accounting/bank_movement";
import {BankMovementEditPage} from "./pages/admin/accounting/bank_movement/form";
import {AmortizationListPage} from "./pages/admin/accounting/amortization";
import {BankStatementPage} from "./pages/admin/accounting/bank_statement";
import {AccountingRuleListPage} from "./pages/admin/accounting/rule";
import {AccountingRuleEditPage} from "./pages/admin/accounting/rule/form";
import {VerifactuListPage} from "./pages/admin/accounting/verifactu";
import {VatBookListPage} from "./pages/admin/accounting/vat_book";
import {VatBookEditPage} from "./pages/admin/accounting/vat_book/form";
import {TaxSubmissionListPage} from "./pages/admin/accounting/tax_submission";
import {TaxSubmissionEditPage} from "./pages/admin/accounting/tax_submission/form";
import {AccountingReportsPage} from "./pages/admin/accounting/reports";
import {AccountingForecastPage} from "./pages/admin/accounting/forecast";
import {ContasolImporterPage} from "./pages/admin/accounting/contasol";
import {ContasolCuadrePage} from "./pages/admin/accounting/contasol/cuadre";
import {AccountLedgerPage} from "./pages/admin/accounting/ledger";

const AdminAccountingRoutes = () => {
    return (
        <Route path="/app/admin/accounting" element={<AccountingLayout/>}>
            <Route index element={<AdminAccountingPage/>}/>

            <Route path="/app/admin/accounting/dashboard" element={<AccountingDashboardPage/>}/>
            <Route path="/app/admin/accounting/alerts" element={<BillAlertsPage/>}/>
            <Route path="/app/admin/accounting/reconciliation" element={<ReconciliationPage/>}/>

            <Route path="/app/admin/accounting/account" element={<AccountingAccountListPage/>}/>
            <Route path="/app/admin/accounting/account/:id" element={<AccountingAccountEditPage/>}/>
            <Route path="/app/admin/accounting/account/new" element={<AccountingAccountEditPage/>}/>

            <Route path="/app/admin/accounting/period" element={<AccountingPeriodListPage/>}/>
            <Route path="/app/admin/accounting/period/:id" element={<AccountingPeriodEditPage/>}/>
            <Route path="/app/admin/accounting/period/new" element={<AccountingPeriodEditPage/>}/>

            <Route path="/app/admin/accounting/journal" element={<JournalEntryListPage/>}/>
            <Route path="/app/admin/accounting/journal/:id" element={<JournalEntryEditPage/>}/>
            <Route path="/app/admin/accounting/journal/new" element={<JournalEntryEditPage/>}/>

            <Route path="/app/admin/accounting/ledger" element={<AccountLedgerPage/>}/>

            <Route path="/app/admin/accounting/supplier" element={<SupplierListPage/>}/>
            <Route path="/app/admin/accounting/supplier/:id" element={<SupplierEditPage/>}/>
            <Route path="/app/admin/accounting/supplier/new" element={<SupplierEditPage/>}/>

            <Route path="/app/admin/accounting/supplier-bill" element={<SupplierBillListPage/>}/>
            <Route path="/app/admin/accounting/supplier-bill/:id" element={<SupplierBillEditPage/>}/>
            <Route path="/app/admin/accounting/supplier-bill/new" element={<SupplierBillEditPage/>}/>

            <Route path="/app/admin/accounting/fixed-asset" element={<FixedAssetListPage/>}/>
            <Route path="/app/admin/accounting/fixed-asset/:id" element={<FixedAssetEditPage/>}/>
            <Route path="/app/admin/accounting/fixed-asset/new" element={<FixedAssetEditPage/>}/>

            <Route path="/app/admin/accounting/bank-account" element={<BankAccountListPage/>}/>
            <Route path="/app/admin/accounting/bank-account/:id" element={<BankAccountEditPage/>}/>
            <Route path="/app/admin/accounting/bank-account/new" element={<BankAccountEditPage/>}/>

            <Route path="bank-movement" element={<BankMovementListPage/>}/>
            <Route path="bank-movement/:id" element={<BankMovementEditPage/>}/>
            <Route path="bank-movement/new" element={<BankMovementEditPage/>}/>
            <Route path="amortization" element={<AmortizationListPage/>}/>
            <Route path="bank-statement" element={<BankStatementPage/>}/>

            <Route path="/app/admin/accounting/rule" element={<AccountingRuleListPage/>}/>
            <Route path="/app/admin/accounting/rule/:id" element={<AccountingRuleEditPage/>}/>
            <Route path="/app/admin/accounting/rule/new" element={<AccountingRuleEditPage/>}/>

            <Route path="verifactu" element={<VerifactuListPage/>}/>
            <Route path="vat-book" element={<VatBookListPage/>}/>
            <Route path="vat-book/:id" element={<VatBookEditPage/>}/>
            <Route path="vat-book/new" element={<VatBookEditPage/>}/>

            <Route path="/app/admin/accounting/tax-submission" element={<TaxSubmissionListPage/>}/>
            <Route path="/app/admin/accounting/tax-submission/:id" element={<TaxSubmissionEditPage/>}/>
            <Route path="/app/admin/accounting/tax-submission/new" element={<TaxSubmissionEditPage/>}/>

            <Route path="/app/admin/accounting/reports" element={<AccountingReportsPage/>}/>
            <Route path="/app/admin/accounting/forecast" element={<AccountingForecastPage/>}/>

            <Route path="contasol" element={<ContasolImporterPage/>}/>
            <Route path="/app/admin/accounting/contasol/cuadre" element={<ContasolCuadrePage/>}/>
			<Route path="/app/admin/accounting/wiki" element={<WikiPageListPage section={SECTION_ACCOUNTING}/>}/>
			<Route path="/app/admin/accounting/wiki/:id" element={<WikiPageEditPage section={SECTION_ACCOUNTING}/>}/>
			<Route path="/app/admin/accounting/wiki/new" element={<WikiPageEditPage section={SECTION_ACCOUNTING}/>}/>
        </Route>
    );
};

export default AdminAccountingRoutes;

export const AdminAccountingMenu = () => {
    return (
        <>
            {/* Resumen */}
            <SideBarItem
                href={"/app/admin/accounting/dashboard"}
                label={"Dashboard"}
                icon={<Dashboard/>}
            />
            <SideBarItem
                href={"/app/admin/accounting/alerts"}
                label={"Vencimientos"}
                icon={<NotificationImportant/>}
            />
            {/* Operativa diaria */}
            <SideBarItem
                href={"/app/admin/accounting/journal"}
                label={"Libro diario"}
                icon={<Book/>}
            />
            <SideBarItem
                href={"/app/admin/accounting/ledger"}
                label={"Extracto de cuenta"}
                icon={<FormatListBulleted/>}
            />
            <SideBarItem
                href={"/app/admin/accounting/amortization"}
                label={"Amortizaciones"}
                icon={<Timeline/>}
            />
            <SideBarItem
                href={"/app/admin/accounting/bank-statement"}
                label={"Conciliación bancaria"}
                icon={<CompareArrows/>}
            />
            <SideBarItem
                href={"/app/admin/accounting/reconciliation"}
                label={"Conciliación asistida"}
                icon={<SyncAlt/>}
            />
            <SideBarItem
                href={"/app/admin/accounting/supplier-bill"}
                label={"Facturas recibidas"}
                icon={<Receipt/>}
            />
            <SideBarItem
                href={"/app/admin/accounting/bank-movement"}
                label={"Movimientos bancarios"}
                icon={<CreditCard/>}
            />
            <SideBarItem
                href={"/app/admin/accounting/reports"}
                label={"Informes"}
                icon={<Assessment/>}
            />
            <SideBarItem
                href={"/app/admin/accounting/forecast"}
                label={"Previsión"}
                icon={<QueryStats/>}
            />
            <SideBarItem
                href={"/app/admin/accounting/contasol"}
                label={"Importar Contasol"}
                icon={<SwapHoriz/>}
            />
            <SideBarItem
                href={"/app/admin/accounting/contasol/cuadre"}
                label={"Cuadre Contasol"}
                icon={<CompareArrows/>}
            />
            {/* Fiscal / periódico */}
            <SideBarItem
                href={"/app/admin/accounting/vat-book"}
                label={"Libros de IVA"}
                icon={<Euro/>}
            />
            <SideBarItem
                href={"/app/admin/accounting/tax-submission"}
                label={"Modelos fiscales"}
                icon={<Description/>}
            />
            <SideBarItem
                href={"/app/admin/accounting/verifactu"}
                label={"VERI*FACTU"}
                icon={<Description/>}
            />
            {/* Maestros */}
            <SideBarItem
                href={"/app/admin/accounting/supplier"}
                label={"Proveedores"}
                icon={<Business/>}
            />
            <SideBarItem
                href={"/app/admin/accounting/account"}
                label={"Plan de cuentas"}
                icon={<AccountTree/>}
            />
            <SideBarItem
                href={"/app/admin/accounting/fixed-asset"}
                label={"Activos fijos"}
                icon={<Savings/>}
            />
            {/* Configuración */}
            <SideBarItem
                href={"/app/admin/accounting/bank-account"}
                label={"Cuentas bancarias"}
                icon={<AccountBalance/>}
            />
            <SideBarItem
                href={"/app/admin/accounting/period"}
                label={"Períodos"}
                icon={<CalendarMonth/>}
            />
            <SideBarItem
                href={"/app/admin/accounting/rule"}
                label={"Reglas contables"}
                icon={<Rule/>}
            />
            <SideBarItem href={"/app/admin/accounting/wiki"} label={"Wiki"} icon={<WikiIcon/>}/>
        </>
    );
};
